import type { LegacyProfile } from '../model/schema';

/**
 * The merchant's display name — `business_name` falling back to `name`, as the
 * old panel does.
 *
 * Deliberately falsy-checked rather than nullish: the backend returns an EMPTY
 * STRING for a merchant that has not set a business name, and `??` would keep
 * it — rendering a blank heading where the old panel shows the personal name.
 *
 * Lives in the entity because two screens title themselves with it (the profile
 * identity card and the branches list's owner heading) and they must not
 * disagree about which field wins.
 */
export function legacyDisplayName(
  profile: LegacyProfile | undefined,
): string | undefined {
  if (!profile) return undefined;
  const name = profile.business_name?.trim() ?? '';
  return name.length > 0 ? name : (profile.name ?? undefined);
}
